// This is an auto-generated file. Do not edit.

export const VERSION = '@civic/credential-client:0.1.3';
